import { registerAppLinks } from "@shared/services/appLinkRegistry";

registerAppLinks([
  {
    uriExpression: "twin-edit.asset.produktion.*",
    routeName: "assetManagementDetail",
  },
  {
    uriExpression: "twin-edit.asset.ticket.produktion.*",
    routeName: "assetManagementTicketDetail",
  },
]);
